
import React from 'react'
import { User } from '../types/auth'



interface UserInfoProps {
  user: User | null
}

export default function UserInfo({ user }: UserInfoProps) {
  // Get display label - show role name, department, or nothing
  // NEVER show "employee" system role
  const getDisplayLabel = () => {
    if (!user) return ''

    // Prefer role name from current engagement
    if (user.employee?.currentEngagement?.roleName) {
      return user.employee.currentEngagement.roleName
    }

    // Fall back to department name
    if (user.employee?.currentEngagement?.departmentName) {
      return user.employee.currentEngagement.departmentName
    }

    // Show system role only if it's NOT "employee"
    if (user.role && user.role !== 'employee') {
      // Capitalize and format role (e.g., 'ceo' -> 'CEO', 'diretor-tecnico' -> 'Diretor Técnico')
      return user.role.toUpperCase().replace('-', ' ')
    }

    // Don't show anything rather than showing "employee"
    return ''
  }

  const displayLabel = getDisplayLabel()

  return (
    <div className="p-4 border-t border-gray-700/50">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-gradient-to-br from-brand-primary to-brand-accent-600 rounded-full flex items-center justify-center shadow-monumenta">
            <span className="text-sm font-bold text-brand-dark font-display">
              {user?.name.charAt(0)}
            </span>
          </div>
        </div>
        <div className="ml-3 flex-1 min-w-0">
          <p className="text-sm font-medium text-white truncate font-display">
            {user?.name}
          </p>
          {displayLabel && (
            <p className="text-xs text-brand-gray-light truncate font-body">
              {displayLabel}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}